import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../headersService";


export const getDriveAnnouncementsDetails = createAsyncThunk('getDriveAnnouncementsDetails', async (notifId, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/notifications/${notifId}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const announcementDetailSlice = createSlice({
    name: 'Announcement Details',
    initialState: {
        loading: false,
        announcementDetail: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getDriveAnnouncementsDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getDriveAnnouncementsDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.announcementDetail = action.payload
        })
        builder.addCase(getDriveAnnouncementsDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})
export default announcementDetailSlice.reducer